
import { Component, Vue, Prop } from 'vue-property-decorator';

import Modal from '@/components/Modal.vue';

@Component({
  name: 'module-popup',
  components: {
    Modal
  }
})
export default class ModulePopup extends Vue {
  @Prop({default: () => {}}) readonly model: object;
  @Prop({default: ''}) readonly title: string;
  @Prop({default: ''}) readonly text: string;
  @Prop({default: true}) readonly hasRequestButton: boolean;
  @Prop({default: false}) readonly hasVideo: boolean;
  @Prop({default: false}) readonly alignCenter: boolean;
  @Prop({default: false}) readonly titleSmall: boolean;

  public isVisible = false;

  get currentLocale() {
    return this.$store.getters['locale/current'];
  };
  get modelName() {
    if (!this.model) {
      return null;
    }

    return this.model.id;
  };
  get nowrapTitle() {
    return (this.modelName === 'survey' && this.currentLocale === 'en') || this.modelName === 'speech-to-text';
  };
  get src() {
    if (!this.modelName) {
      return '';
    }

    return `module-${this.modelName === 'test' ? 'tests' : this.modelName}-${this.currentLocale}`;
  };
  get popupTitle() {
    if (!this.title) {
      return this.$tr('vacancy.modules.survey.title');
    }
    return this.title;
  };
  get popupText() {
    if (!this.text) {
      return this.$tr('vacancy.modules.survey.text');
    }
    return this.text;
  };

  public close() {
    this.$emit('close');
      this.isVisible = false;
  };
  public submit() {
    this.$emit('submit', this.model);
  };

  beforeMount() {
    this.isVisible = true;
  }
}
